require("!!/home/hellomojito/agency-space/node_modules/script-loader/addScript.js")(require("!!/home/hellomojito/agency-space/node_modules/raw-loader/index.js!/home/hellomojito/agency-space/assets/plugins/switchery/js/switchery.min.js"))


//////////////////
// WEBPACK FOOTER
// ./assets/plugins/switchery/js/switchery.min.js
// module id = 655
// module chunks = 0